import * as React from "react";
const SvgFiRrObjectSubtract = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-object-subtract_svg__a)">
      <path
        fill="#062147"
        d="M3 15.83a1 1 0 0 1-.33-.06 3.94 3.94 0 0 1-2.44-2.44c-.18-.52.09-1.09.61-1.28.52-.18 1.09.09 1.28.61.2.56.65 1.02 1.22 1.22a1.003 1.003 0 0 1-.33 1.95zm7-.83c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1m3.33.77a3.94 3.94 0 0 0 2.44-2.44c.18-.52-.09-1.09-.61-1.28-.52-.18-1.09.09-1.28.61-.2.56-.65 1.02-1.22 1.22a1.003 1.003 0 0 0 .33 1.95q.165 0 .33-.06zM16 9V7c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1m-6-8c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1M2 9V7c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1m22 10v-6c0-2.76-2.24-5-5-5-.55 0-1 .45-1 1s.45 1 1 1c1.65 0 3 1.35 3 3v6c0 1.65-1.35 3-3 3h-6c-1.65 0-3-1.35-3-3 0-.55-.45-1-1-1s-1 .45-1 1c0 2.76 2.24 5 5 5h6c2.76 0 5-2.24 5-5M2.11 3.33c.2-.56.65-1.02 1.22-1.22.52-.18.79-.75.61-1.28a1 1 0 0 0-1.27-.6A3.94 3.94 0 0 0 .23 2.67a1.01 1.01 0 0 0 .94 1.34c.41 0 .8-.26.94-.67zm13.05.61c.52-.18.79-.75.61-1.28A3.94 3.94 0 0 0 13.33.22c-.52-.18-1.09.09-1.28.61-.18.52.09 1.09.61 1.28.56.2 1.02.65 1.22 1.22.15.41.53.67.94.67q.165 0 .33-.06z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-object-subtract_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrObjectSubtract;
